module.exports = __webpack_public_path__ + "img/IT0000100777748.d1eba93b.png";